<a id="downloadFile" style="display: none" aria-label="Descarga de archivo" tabindex="-1"></a>

@if (variant === 'compact') {
<footer class="public-footer--compact" role="contentinfo">
  @if (showLogoOnly) {
  <div class="public-footer--compact__inner public-footer--compact__inner--logo">
    <img src="assets/img/Home/svg/logo-neocredito-header.svg" alt="neocrédito" class="public-footer--compact__logo" />
  </div>
  } @else {
  <div class="public-footer--compact__inner">
    <button
      type="button"
      class="public-footer--compact__link"
      (click)="abrirRecomendacionesSeguridad()"
    >
      <span class="public-footer--compact__text public-footer--compact__text--desktop">
        <strong>Conoce aquí</strong>
        nuestras recomendaciones de seguridad para inicio de sesión en dispositivos
      </span>
      <span class="public-footer--compact__text public-footer--compact__text--mobile">
        <strong>Conoce</strong>
        nuestras recomendaciones de seguridad
      </span>
    </button>
  </div>
  }
</footer>
} @else if (variant === 'v2') {
<footer class="public-footer public-footer--v2" role="contentinfo">
  @if (showLogoOnly) {
  <div class="public-footer--v2__content public-footer--v2__content--logo">
    <img src="assets/img/Home/svg/logo-neocredito-header.svg" alt="neocrédito" class="public-footer--v2__logo" />
  </div>
  } @else {
  <button type="button" class="public-footer--v2__content" (click)="abrirRecomendacionesSeguridad()"
    (keydown)="onKeydown($event)">
    <img src="assets/img/icos/lock.svg" alt="" class="public-footer--v2__icon" aria-hidden="true" />
    <p class="public-footer--v2__text">
      <strong>Conoce aquí</strong>
      nuestras recomendaciones de seguridad para inicio de sesión en dispositivos
    </p>
  </button>
  }
</footer>
} @else {
<footer class="public-footer">
  @if (showLogoOnly) {
  <div class="public-footer__content public-footer__content--logo">
    <img src="assets/img/Inicio_sesion/svg/logo_neocredito.svg" alt="neocrédito - Microcrédito en un solo lugar"
      class="public-footer__logo" />
  </div>
  } @else {
  <button type="button" class="public-footer__content" (click)="abrirRecomendacionesSeguridad()"
    (keydown)="onKeydown($event)">
    <img src="assets/img/icos/lock.svg" alt="" class="public-footer__icon" aria-hidden="true" />
    <p class="m-0 public-footer__text">
      <strong>Conoce aquí</strong>
      nuestras recomendaciones de seguridad para inicio de sesión en dispositivos
    </p>
  </button>
  }
</footer>
}
